import { render } from "./CustomDropdown.vue?vue&type=template&id=6489e46a&scoped=true&ts=true"
import script from "./CustomDropdown.vue?vue&type=script&lang=ts"
export * from "./CustomDropdown.vue?vue&type=script&lang=ts"

import "./CustomDropdown.vue?vue&type=style&index=0&id=6489e46a&scoped=true&lang=css"

import exportComponent from "/app/purple__bee/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6489e46a"]])

export default __exports__